import React, { useEffect, useState } from "react";
import { parceiroHorarios, salvarParceiroHorarios, parceiroAulas, parceiroLivres, parceiroAcaoAula } from "../services/api";
import { quando, STATUS_AULA, EscolherHorario } from "./AulasComum";

// 🎓 Painel do parceiro, etapa 2 (17/10/2026): horários da aula grátis + pedidos e aulas.
const DIAS = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];

export function HorariosParceiro() {
  const [lista, setLista] = useState(null);
  const [novo, setNovo] = useState({ diaSemana: 1, hora: "19:00", duracaoMin: 60, vagas: 1 });
  const [salvo, setSalvo] = useState("");
  const [erro, setErro] = useState("");
  useEffect(() => { parceiroHorarios().then(setLista).catch((e) => setErro(e.message)); }, []);
  const salvar = async (nova) => {
    setErro(""); setSalvo("");
    try { setLista(await salvarParceiroHorarios(nova)); setSalvo("✓ Horários salvos"); }
    catch (e) { setErro(e.message); }
  };
  if (!lista) return <p className="text-sm text-gray-400">{erro || "Carregando horários…"}</p>;
  const ordenada = [...lista].sort((a, b) => a.diaSemana - b.diaSemana || a.hora.localeCompare(b.hora));
  return (
    <div>
      <p className="text-sm text-gray-600">Horários da semana em que você pode dar a aula grátis (horário de Brasília). Os candidatos escolhem entre eles, a partir de 12 horas no futuro.
        Num horário de <b>turma</b>, vários alunos pedem o mesmo horário e entram na mesma sala.</p>
      <div className="flex flex-wrap gap-1.5 mt-3">
        {ordenada.length === 0 && <span className="text-sm text-gray-400">Nenhum horário ainda.</span>}
        {ordenada.map((h) => (
          <span key={`${h.diaSemana}-${h.hora}`} className="inline-flex items-center gap-1 rounded-full bg-sky-100 text-sky-900 text-xs font-semibold px-2.5 py-1">
            {DIAS[h.diaSemana]} {h.hora} · {h.duracaoMin} min · {h.vagas > 1 ? `turma de ${h.vagas}` : "individual"}
            <button aria-label="Tirar horário" onClick={() => salvar(lista.filter((x) => !(x.diaSemana === h.diaSemana && x.hora === h.hora)))}>×</button>
          </span>
        ))}
      </div>
      <div className="flex flex-wrap items-end gap-2 mt-3 text-sm">
        <select value={novo.diaSemana} onChange={(e) => setNovo({ ...novo, diaSemana: Number(e.target.value) })} className="border rounded-lg px-2 py-1.5">
          {DIAS.map((d, i) => <option key={d} value={i}>{d}</option>)}
        </select>
        <input type="time" value={novo.hora} onChange={(e) => setNovo({ ...novo, hora: e.target.value })} className="border rounded-lg px-2 py-1.5" />
        <select value={novo.duracaoMin} onChange={(e) => setNovo({ ...novo, duracaoMin: Number(e.target.value) })} className="border rounded-lg px-2 py-1.5">
          {[30, 45, 60, 90].map((m) => <option key={m} value={m}>{m} min</option>)}
        </select>
        <select value={novo.vagas} onChange={(e) => setNovo({ ...novo, vagas: Number(e.target.value) })} className="border rounded-lg px-2 py-1.5" title="Quantos alunos neste horário">
          <option value={1}>Individual (1 aluno)</option>
          {[2, 3, 4, 5, 6, 8, 10, 15, 20].map((n) => <option key={n} value={n}>Turma de {n} alunos</option>)}
        </select>
        <button onClick={() => salvar([...lista, novo])} className="bg-slate-100 hover:bg-slate-200 font-bold rounded-lg px-3 py-1.5">Adicionar horário</button>
        {salvo && <span className="text-green-700 text-xs">{salvo}</span>}
      </div>
      {erro && <p className="text-red-600 text-sm mt-2">{erro}</p>}
    </div>
  );
}

export function AulasDoParceiro() {
  const [aulas, setAulas] = useState(null);
  const [erro, setErro] = useState("");
  const [escolhendo, setEscolhendo] = useState(null);   // aula em que o parceiro está escolhendo outro horário
  const [livres, setLivres] = useState([]);
  const [escolha, setEscolha] = useState(null);
  const carregar = () => parceiroAulas().then(setAulas).catch((e) => setErro(e.message));
  useEffect(() => { carregar(); }, []);
  const acao = async (a, nome, inicio) => {
    setErro("");
    try { await parceiroAcaoAula(a.id, nome, inicio); setEscolhendo(null); setEscolha(null); carregar(); }
    catch (e) { setErro(e.message); }
  };
  const abrirEscolha = (a) => { setEscolhendo(a.id); setEscolha(null); parceiroLivres().then(setLivres).catch(() => setLivres([])); };
  if (!aulas) return <p className="text-sm text-gray-400">{erro || "Carregando…"}</p>;
  if (!aulas.length) return <p className="text-sm text-gray-500">Nenhum pedido ainda. Quando um candidato pedir aula, você recebe e-mail e aviso no sino.</p>;
  return (
    <div>
      {erro && <p className="text-red-600 text-sm mb-2">{erro}</p>}
      <ul className="divide-y">
        {aulas.map((a) => (
          <li key={a.id} className="py-3 text-sm">
            <div className="flex flex-wrap items-center gap-2">
              <b>{a.com}</b>{a.skill && <span className="text-gray-500">· {a.skill}</span>}
              <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_AULA[a.status]?.cls || "bg-slate-100"}`}>{a.status === "pedida" ? "Novo pedido" : STATUS_AULA[a.status]?.txt || a.status}</span>
            </div>
            <div className="text-gray-600 mt-0.5">{quando(a.inicio)} · {a.duracaoMin} min</div>
            {a.mensagem && <div className="text-gray-500 italic mt-1">“{a.mensagem}”</div>}
            {a.prazoResposta && a.status === "pedida" && <div className="text-xs text-amber-700 mt-1">Responda até {quando(a.prazoResposta)}; depois disso o pedido expira.</div>}
            {a.status === "sugerida" && <div className="text-xs text-gray-500 mt-1">Você sugeriu {quando(a.sugeridoInicio)}. Aguardando o aluno.</div>}
            {a.status === "confirmada" && a.remarcacaoPor === "aluno" && (
              <div className="mt-2 rounded-xl bg-amber-50 border border-amber-200 p-2">
                O aluno pediu para remarcar para <b>{quando(a.sugeridoInicio)}</b>{a.prazoResposta && <> (responda até {quando(a.prazoResposta)})</>}.
                <button onClick={() => acao(a, "aprovar")} className="ml-2 bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs">Aceitar</button>
                <button onClick={() => acao(a, "recusar")} className="ml-1 bg-slate-100 font-bold rounded-lg px-3 py-1 text-xs">Manter o horário de antes</button>
              </div>
            )}
            {a.status === "confirmada" && a.remarcacaoPor === "prof" && <div className="text-xs text-gray-500 mt-1">Você propôs remarcar para {quando(a.sugeridoInicio)}. Aguardando o aluno.</div>}
            <div className="flex flex-wrap gap-2 mt-2">
              {a.status === "pedida" && <button onClick={() => acao(a, "aprovar")} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-xs">Aprovar</button>}
              {(a.status === "pedida" || (a.status === "confirmada" && a.podeMexer && !a.remarcacaoPor && a.remarcacoesRestantes > 0)) && (
                <button onClick={() => abrirEscolha(a)} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-xs">{a.status === "pedida" ? "Sugerir outro horário" : "Remarcar"}</button>
              )}
              {a.status === "pedida" && <button onClick={() => window.confirm("Recusar este pedido?") && acao(a, "recusar")} className="text-red-600 text-xs font-semibold">Recusar</button>}
              {a.link && <a href={a.link} className="bg-brand text-white font-bold rounded-lg px-3 py-1.5 text-xs">Entrar na sala</a>}
              {a.status === "confirmada" && a.podeMexer && <button onClick={() => window.confirm("Cancelar esta aula? O aluno será avisado.") && acao(a, "cancelar")} className="text-red-600 text-xs font-semibold">Cancelar</button>}
            </div>
            {escolhendo === a.id && (
              <div className="mt-2 rounded-xl border p-2">
                <EscolherHorario livres={livres} valor={escolha} onChange={setEscolha} vazio="Sem outro horário livre nos próximos 14 dias. Abra mais horários acima." />
                <div className="flex gap-2 mt-2">
                  <button disabled={!escolha} onClick={() => acao(a, "sugerir", escolha)} className="bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs disabled:opacity-40">Enviar ao aluno</button>
                  <button onClick={() => setEscolhendo(null)} className="text-xs">Voltar</button>
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-gray-400 mt-2">Pedidos: responda em até 24 horas. Remarcar e cancelar: até 12 horas antes; cada aula pode ser remarcada até 2 vezes.</p>
    </div>
  );
}
